var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _path1, _g5, _path10, _path11, _g6, _path12, _g7, _path13, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9406_6021)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 42,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0229 7.48888C8.54967 7.48888 6.52637 9.51252 6.52637 11.9856V51.2946C6.52637 53.7679 8.54967 55.7915 11.0229 55.7915H42.7744C45.2476 55.7915 47.2711 53.7679 47.2711 51.2946V18.6162C47.2711 17.6413 46.8586 16.7118 46.1356 16.058L37.6468 8.38023C37.0128 7.80649 36.1878 7.48888 35.3328 7.48888H11.0229Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9406_6021)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3328 7.48955H11.0227C8.54982 7.48955 6.52637 9.513 6.52637 11.9863V51.2953C6.52637 53.7685 8.54982 55.792 11.0227 55.792H42.7743C45.2476 55.792 47.2711 53.7685 47.2711 51.2953V18.6169C47.2711 17.642 46.8586 16.7125 46.1354 16.0585L37.6468 8.38073C37.0126 7.80715 36.1878 7.48955 35.3328 7.48955Z",
    fill: "#E7E7E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 15,
    width: 11,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4355 15.4687H47.2709V24.0427H37.4355V15.4687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4355 17.2951L47.271 24.0398V15.4671L37.4355 17.2951Z",
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9346 6.8306L48.8317 18.4954H40.535C37.9942 18.4954 35.9346 16.4358 35.9346 13.8951V13.6488V6.8306Z",
    fill: "#D2D3D4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 7,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03809 8.98933H14.9186V14.2472H8.03809V8.98933Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.610001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8385 14.2258C8.2911 14.1083 7.94226 13.5696 8.05994 13.0217C8.64989 10.2724 11.3666 8.51539 14.1163 9.10534C14.6637 9.22285 15.0124 9.76147 14.8949 10.3094C14.7773 10.8573 14.2382 11.2053 13.6908 11.0879C12.0346 10.7325 10.3978 11.7908 10.0424 13.4472C9.92502 13.9951 9.3859 14.3431 8.8385 14.2258Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -5,
    width: 39,
    height: 38
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.4873 -4.70302H32.1199V32.9042H-5.4873V-4.70302Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.649994
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1191 14.101C32.1191 24.4857 23.7007 32.9041 13.316 32.9041C2.93122 32.9041 -5.4873 24.4857 -5.4873 14.101C-5.4873 3.71622 2.93122 -4.7023 13.316 -4.7023C23.7007 -4.7023 32.1191 3.71622 32.1191 14.101Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -505,
    y: -390,
    width: 607,
    height: 782
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-504.347 -389.85H101.821V391.75H-504.347V-389.85Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9406_6021)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 24,
    width: 31,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 24.0456H41.5106V44.3444H11.9844V24.0456Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.270004
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9445 27.3425H13.5514C12.6895 27.3425 11.9844 26.6374 11.9844 25.7756V25.6139C11.9844 24.7519 12.6895 24.0468 13.5514 24.0468H39.9445C40.8063 24.0468 41.5112 24.7519 41.5112 25.6139V25.7756C41.5112 26.6374 40.8063 27.3425 39.9445 27.3425Z",
    fill: "#323139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9445 35.8412H13.5514C12.6895 35.8412 11.9844 35.1361 11.9844 34.2745V34.1125C11.9844 33.2507 12.6895 32.5456 13.5514 32.5456H39.9445C40.8063 32.5456 41.5112 33.2507 41.5112 34.1125V34.2745C41.5112 35.1361 40.8063 35.8412 39.9445 35.8412Z",
    fill: "#323139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9445 44.3461H13.5514C12.6895 44.3461 11.9844 43.641 11.9844 42.7793V42.6174C11.9844 41.7556 12.6895 41.0505 13.5514 41.0505H39.9445C40.8063 41.0505 41.5112 41.7556 41.5112 42.6174V42.7793C41.5112 43.641 40.8063 44.3461 39.9445 44.3461Z",
    fill: "#323139"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 42,
    height: 50
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0065 3.73998C17.5334 3.73998 15.5098 5.76341 15.5098 8.23668V47.5457C15.5098 50.0188 17.5334 52.0422 20.0065 52.0422H51.7581C54.2312 52.0422 56.2546 50.0188 56.2546 47.5457V14.8673C56.2546 13.8922 55.8421 12.9629 55.1191 12.3088L46.6302 4.63113C45.9964 4.05756 45.1715 3.73998 44.3162 3.73998H20.0065Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9406_6021)"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3171 3.74138H20.0073C17.5342 3.74138 15.5107 5.76484 15.5107 8.2381V47.5471C15.5107 50.0204 17.5342 52.0438 20.0073 52.0438H51.7587C54.232 52.0438 56.2554 50.0204 56.2554 47.5471V14.8687C56.2554 13.8938 55.8429 12.9643 55.1198 12.3103L46.6312 4.63256C45.997 4.05898 45.1722 3.74138 44.3171 3.74138Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 11,
    width: 11,
    height: 10
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4199 11.7201H56.2552V20.2925H46.4199V11.7201Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.0700073
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4199 13.5479L56.2552 20.2928V11.72L46.4199 13.5479Z",
    fill: "black"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9189 3.08267L57.8161 14.7474H49.5193C46.9785 14.7474 44.9189 12.6878 44.9189 10.1472V9.90086V3.08267Z",
    fill: "#E7E7E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 7,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0205 5.24077H23.901V10.4969H17.0205V5.24077Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.610001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8219 10.4694C17.2745 10.3519 16.9257 9.81329 17.0433 9.26539C17.6333 6.51606 20.35 4.75904 23.0999 5.34899C23.6471 5.46651 23.9958 6.00513 23.8783 6.55303C23.7607 7.10094 23.2216 7.44893 22.6742 7.33159C21.018 6.97616 19.3812 8.03449 19.0259 9.69088C18.9084 10.2388 18.3693 10.5868 17.8219 10.4694Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: -9,
    width: 39,
    height: 39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49707 -8.44557H41.1026V29.1616H3.49707V-8.44557Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.639999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1034 10.3584C41.1034 20.7431 32.6851 29.1615 22.3003 29.1615C11.9156 29.1615 3.49707 20.7431 3.49707 10.3584C3.49707 -0.0263367 11.9156 -8.44486 22.3003 -8.44486C32.6851 -8.44486 41.1034 -0.0263367 41.1034 10.3584Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_9406_6021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 31,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9678 20.286H50.4957V40.5864H20.9678V20.286Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_9406_6021)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.520004
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9287 23.5812H22.5356C21.6739 23.5812 20.9688 22.8761 20.9688 22.0143V21.8525C20.9688 20.9906 21.6739 20.2856 22.5356 20.2856H48.9287C49.7905 20.2856 50.4955 20.9906 50.4955 21.8525V22.0143C50.4955 22.8761 49.7905 23.5812 48.9287 23.5812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9287 32.0837H22.5356C21.6739 32.0837 20.9688 31.3788 20.9688 30.517V30.3553C20.9688 29.4933 21.6739 28.7882 22.5356 28.7882H48.9287C49.7905 28.7882 50.4955 29.4933 50.4955 30.3553V30.517C50.4955 31.3788 49.7905 32.0837 48.9287 32.0837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9287 40.5847H22.5356C21.6739 40.5847 20.9688 39.8796 20.9688 39.018V38.8561C20.9688 37.9943 21.6739 37.2892 22.5356 37.2892H48.9287C49.7905 37.2892 50.4955 37.9943 50.4955 38.8561V39.018C50.4955 39.8796 49.7905 40.5847 48.9287 40.5847Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9406_6021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.b0ed331eb219767c93a5b80e3ca32703.svg";
export { ForwardRef as ReactComponent };